import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import "./NavbarReviewer.css";

const NavbarReviewer = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  return (
    <nav className="reviewer-navbar-12ab">

      {/* LEFT: Logo */}
      <div
        className="reviewer-navbar-left-12ab"
        onClick={() => navigate("/reviewer/pipelines/applicant")}
      >
        <img
        //   src="/navbar/drishtilogo.jpg"
          src="/navbar/drishtilogobackground.png"
          alt="Logo"
          className="reviewer-navbar-logo-12ab"
        />
      </div>

      {/* CENTER TITLE */}
      <div className="reviewer-navbar-center-12ab">
        Reviewer Panel
      </div>

      {/* RIGHT: Profile + Logout */}
      <div className="reviewer-navbar-right-12ab">

        {/* Profile Icon */}
        <FaUserCircle
          className="reviewer-navbar-profile-icon-12ab"
          onClick={() => setShowDropdown(!showDropdown)}
        />

        {/* Dropdown */}
        {showDropdown && (
          <div className="reviewer-navbar-dropdown-12ab">
            <p className="dropdown-label-12ab">Reviewer</p>
            <p className="dropdown-value-12ab">Profile</p>
          </div>
        )}
<button className="reviewer-logout-btn-ab12">
  <img
    src="/navbar/logout-icon.png"
    alt="logout icon"
    className="logout-icon-ab12"
  />
  <span>Logout</span>
</button>
      </div>

    </nav>
  );
};

export default NavbarReviewer;


 